import { TableColumn } from '@shared/components/data-table/data-table.component';
import { FormField, ActionButton } from '@shared/components/add-form/add-form.component';
import { FormFieldConfig } from '@shared/components/search-form/search-form.component';

// ============================================================================
// INTERFACES
// ============================================================================

export interface PriceItem {
	lovValueId: number;
	lovId: number;
	lovCode: string;
	value: string;
	meaning: string;
	/** Computed from LOV by matching `value`; not provided by API */
	valueMeaning?: string;
	description?: string | null;
	tenantId: number;
	orderSeq: number;
	status: number;
	creationDate: string | null;
	createdBy: string | null;
	lastUpdateDate: string | null;
	lastUpdatedBy: string | null;
	objectVersionNumber: number;
	_token: string;
}

export interface PriceItemFormConfig {
	title: string;
	formFields: FormField[];
	headerActions: ActionButton[];
	listRoute: string;
}

// ============================================================================
// FORM FIELD OPTIONS
// ============================================================================

export const PRICE_ITEM_STATUS_OPTIONS = [
	{ label: 'goods.pricing.status.active', value: 1 },
	{ label: 'goods.pricing.status.inactive', value: 0 }
];

export const PRICE_CODE_OPTIONS = [
	{ label: 'goods.pricing.price_types.cost_price', value: 'costPrice' },
	{ label: 'goods.pricing.price_types.sales_price', value: 'salesPrice' },
	{ label: 'goods.pricing.price_types.activity_price', value: 'activityPrice' },
	{ label: 'goods.pricing.price_types.market_price', value: 'marketPrice' },
	{ label: 'goods.pricing.price_types.distribution_price', value: 'distributionPrice' },
	{ label: 'goods.pricing.price_types.wholesale_price', value: 'wholesalePrice' },
	{ label: 'goods.pricing.price_types.clearing_price', value: 'clearingPrice' },
	{ label: 'goods.pricing.price_types.internal_allocation_price', value: 'JG004' }
];

// ============================================================================
// TABLE CONFIGURATION
// ============================================================================

export const PRICE_ITEM_TABLE_COLUMNS: TableColumn[] = [
	{ label: 'goods.pricing.table.columns.price_code', prop: 'value', width: 150, type: 'text' },
	{ label: 'goods.pricing.table.columns.standard_price_type', prop: 'valueMeaning', width: 200, type: 'custom' },
	{ label: 'goods.pricing.table.columns.marketplace_price_name', prop: 'meaning', width: 180, type: 'text' },
	{ label: 'goods.pricing.table.columns.remarks', prop: 'description', width: 200, type: 'text' },
	{ label: 'goods.pricing.table.columns.status', prop: 'status', width: 120, type: 'status' },
	{ label: 'goods.pricing.table.columns.actions', prop: 'actions', width: 150, type: 'actions' }
];

// ============================================================================
// SEARCH CONFIGURATION
// ============================================================================

export const PRICE_ITEM_SEARCH_CONFIG: FormFieldConfig[] = [
	{
		key: 'value',
		label: 'goods.pricing.search.fields.price_code',
		type: 'text',
		placeholder: 'goods.pricing.search.placeholders.enter_price_code'
	},
	{
		key: 'meaning',
		label: 'goods.pricing.search.fields.marketplace_price_name',
		type: 'text',
		placeholder: 'goods.pricing.search.placeholders.enter_marketplace_price_name'
	},
	{
		key: 'status',
		label: 'goods.pricing.search.fields.status',
		type: 'select',
		placeholder: 'goods.pricing.search.placeholders.select_status',
		options: PRICE_ITEM_STATUS_OPTIONS,
		showClear: true
	}
];


